<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
    <div :class="cn('gap-xs flex flex-col-reverse sm:flex-row sm:justify-end', props.class)">
        <slot />
    </div>
</template>
